if (!customElements.get('xz-label-studio')) {
  customElements.define('xz-label-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.shop = this.querySelector('[data-shop-name]');
      this.logo = this.querySelector('[data-logo-preview]');
      this.file = this.querySelector('[data-logo-file]');
      this.status = this.querySelector('[data-file-status]');
      this.remove = this.querySelector('[data-remove-logo]');
      this.form = this.querySelector('[data-label-form]');
      this.buy = this.querySelector('[data-label-buy]');
      this.quantity = this.querySelector('[data-label-quantity]');
      this.confirm = this.querySelector('[data-label-confirm]');
      this.orderStatus = this.querySelector('[data-purchase-status]');
      this.form.addEventListener('submit', event => { event.preventDefault(); this.purchase(); });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-machine-name], [data-machine-variant], [data-label-quantity]')) { this.confirm.checked = false; this.update(); }
        if (event.target === this.file) this.previewLogo();
      });
      this.quantity.addEventListener('input', () => { this.confirm.checked = false; this.update(); });
      this.shop.addEventListener('input', () => this.update());
      this.remove.addEventListener('click', () => this.clearLogo());
      this.querySelectorAll('[data-load-model]').forEach(button => button.addEventListener('click', () => this.loadModel(button)));
      this.update();
    }
    disconnectedCallback() {
      if (this.logoURL) URL.revokeObjectURL(this.logoURL);
    }
    update() {
      const choice = this.querySelector('[data-machine-name]:checked');
      if (!choice) return;
      this.querySelectorAll('[data-machine-panel]').forEach(panel => { panel.hidden = panel.dataset.machinePanel !== choice.value; });
      const shop = this.shop.value.trim();
      this.querySelector('[data-name-preview]').textContent = shop || 'YOUR SHOP';
      const message = `Hi Xwitzeal! I would like a custom shop logo label for ${choice.dataset.machineName} at US$2 per machine.${shop ? ` My shop name is ${shop}.` : ''} I will attach my original logo file here. Please help confirm quantity, label size, placement and order details.`;
      const phone = this.dataset.phone.replace(/\D/g, '');
      this.querySelector('[data-custom-request]').href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      const panel = this.querySelector('[data-machine-panel]:not([hidden])');
      const ready = panel.dataset.labelReady === 'true';
      this.buy.disabled = this.busy || this.recovery || !ready || this.dataset.serviceAvailable !== 'true';
      this.confirm.disabled = !ready;
      if (!this.busy && !this.recovery) this.orderStatus.textContent = !ready ? 'Q1 placement preview is not ready yet. Contact our team to arrange your label.' : !this.dataset.serviceId ? 'Label ordering is being prepared. Please contact our team.' : '';
      const option = panel.querySelector('[data-machine-variant]').selectedOptions[0];
      const qty = Number(this.quantity.value);
      const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100);
      const validQty = Number.isInteger(qty) && qty > 0 && qty <= 50;
      const serviceTotal = Number(this.dataset.servicePrice) * qty;
      const machineTotal = Number(option?.dataset.price) * qty;
      this.querySelector('[data-service-total]').textContent = validQty ? `${money(serviceTotal)} (${qty} × ${money(Number(this.dataset.servicePrice))})` : 'Enter a quantity';
      this.querySelector('[data-machine-total]').textContent = validQty && option?.value ? money(machineTotal) : 'Choose a configuration';
      this.querySelector('[data-label-total]').textContent = validQty && option?.value ? money(serviceTotal + machineTotal) : '—';
    }
    clearLogo(clearFile = true) {
      if (this.logoURL) URL.revokeObjectURL(this.logoURL);
      this.logoURL = null;
      this.logo.removeAttribute('src');
      this.logo.hidden = true;
      this.logoReady = false;
      this.confirm.checked = false;
      this.querySelectorAll('[data-machine-label]').forEach(label => { label.hidden = true; label.querySelector('img').removeAttribute('src'); });
      this.querySelector('[data-name-preview]').hidden = false;
      this.remove.hidden = true;
      if (clearFile) this.file.value = '';
      this.status.textContent = 'Choose your original logo to preview it on the machine. It will be saved with your order when you continue.';
    }
    previewLogo() {
      const file = this.file.files[0];
      if (!file) return;
      if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) {
        this.clearLogo();
        this.status.textContent = 'Choose a PNG, JPG or WebP image no larger than 5 MB.';
        return;
      }
      this.clearLogo(false);
      this.logoURL = URL.createObjectURL(file);
      this.logo.onload = () => {
        this.logoReady = true;
        this.logo.hidden = false;
        this.querySelector('[data-name-preview]').hidden = true;
        this.remove.hidden = false;
        this.querySelectorAll('[data-machine-label]').forEach(label => { label.querySelector('img').src = this.logoURL; label.hidden = false; });
        this.querySelectorAll('model-viewer').forEach(viewer => viewer.hidden = true);
        this.querySelectorAll('.xz-custom-label__poster').forEach(poster => poster.hidden = false);
        this.status.textContent = 'Preview ready. Check the logo on the front panel, then confirm below. Your original image will be saved with your order.';
      };
      this.logo.onerror = () => {
        this.clearLogo();
        this.status.textContent = 'This image could not be opened. Please choose another image.';
      };
      this.logo.src = this.logoURL;
    }
    async purchase() {
      if (this.busy || this.recovery || window.xzLabelPurchaseBusy) return;
      const panel = this.querySelector('[data-machine-panel]:not([hidden])');
      const variant = panel.querySelector('[data-machine-variant]');
      if (panel.dataset.labelReady !== 'true' || this.dataset.serviceAvailable !== 'true') return;
      if (!variant.reportValidity() || !this.form.reportValidity()) return;
      if (!this.logoReady || !this.file.files[0]) { this.orderStatus.textContent = 'Please upload a valid logo and wait for its preview.'; return; }
      this.busy = window.xzLabelPurchaseBusy = true;
      this.buy.disabled = true;
      const controls = [...this.querySelectorAll('input,select,button')];
      const disabled = controls.map(control => control.disabled);
      controls.forEach(control => control.disabled = true);
      try {
        await window.XZLabelOrder.add({serviceId:this.dataset.serviceId,variantId:variant.value,model:this.querySelector('[data-machine-name]:checked').dataset.machineName,configuration:variant.selectedOptions[0].textContent.split(' — ')[0],quantity:Number(this.quantity.value),file:this.file.files[0],shop:this.shop.value.trim(),placement:panel.dataset.placement,onProgress:text => this.orderStatus.textContent = text});
        this.orderStatus.textContent = 'Logo saved. Your machine and label service are ready. Opening checkout…';
        window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch (error) {
        this.orderStatus.textContent = error.message || 'Unable to prepare your order. Please try again.';
        this.recovery = Boolean(error.reviewCart);
        this.querySelector('[data-recovery-cart]').hidden = !this.recovery;
        controls.forEach((control,index) => control.disabled = disabled[index]);
        this.busy = window.xzLabelPurchaseBusy = false;
        this.buy.disabled = this.recovery;
      }
    }
    loadModel(button) {
      const panel = button.closest('[data-machine-panel]');
      const stage = panel.querySelector('.xz-custom-label__stage');
      const status = panel.querySelector('[data-model-status]');
      if (stage.querySelector('model-viewer')) return;
      button.disabled = true;
      button.textContent = 'Loading 3D…';
      const fail = () => {
        clearTimeout(timer);
        stage.querySelector('model-viewer')?.remove();
        panel.querySelector('.xz-custom-label__poster').hidden = false;
        button.hidden = false;
        button.disabled = false;
        button.textContent = 'Retry 3D view ↗';
        status.textContent = 'The 3D view could not load. You can still explore the product photo or contact our team.';
      };
      const timer = setTimeout(fail, 30000);
      const show = () => {
        if (!this.isConnected || !button.disabled) return;
        const viewer = panel.querySelector('[data-model-template]').content.querySelector('model-viewer').cloneNode(true);
        viewer.addEventListener('load', () => {
          clearTimeout(timer);
          button.hidden = true;
          panel.querySelector('.xz-custom-label__poster').hidden = true;
          status.textContent = 'Drag to rotate · Pinch or scroll to zoom. The label design is previewed separately.';
        }, {once:true});
        viewer.addEventListener('error', fail, {once:true});
        stage.appendChild(viewer);
      };
      if (customElements.get('model-viewer')) show();
      else if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:errors => errors ? fail() : show()}]);
      } else fail();
    }
  });
}
